import React, { Component } from "react";
import styles from "./SearchBox.module.css";
import PreLoader from "../PreLoader/PreLoader";

function SearchBox() {
  return (
    <>
      <div className={`${styles.SearchBoxCont} `}>
        <div className={`${styles.SearchBox} `}>
          <PreLoader>در حال حاضر فعال نیست</PreLoader>
        </div>
      </div>
    </>
  );
}

export default SearchBox;
